import TooltipWrapper from "@app/shared/TooltipWrapper";

interface WaffleRowTooltipProps {
  elements: string[];
  containerClassName?: string;
  numberOfElementsPerRow: number;
  separator?: string;
}

const WaffleRowTooltip: React.FC<WaffleRowTooltipProps> = ({ elements, containerClassName, numberOfElementsPerRow, separator = '; ' }) => {

  const displayedElements = elements.length > numberOfElementsPerRow ? 
                            `${elements.slice(0, numberOfElementsPerRow).join(separator)}${separator}...` :
                            elements.join(separator); 

  const showTooltip = elements.length > numberOfElementsPerRow;                    

  return (
    <>
      {showTooltip ? (
        <TooltipWrapper 
          containerClassName={containerClassName}
          position="auto"
          text={
            <ul className="list-unstyled mb-0">
              {elements.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
           </ul>
          }
         >
          <p>{displayedElements}</p>
        </TooltipWrapper>    
      ) :
      (
        <div>{displayedElements}</div>
      )}
    </>
  );
};

export default WaffleRowTooltip;